import { ChevronRightSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { PatternsTheme } from './PatternsTheme';

export const panelTheme: PatternsTheme = {
  name: 'panel',
  containerLayout: 'panel',
  loader: {
    size: 'small',
  },
  sizes: {
    small: 'tiny',
    medium: 'small',
  },
  toolbar: {
    item: {
      size: 'tiny',
    },
    button: {
      suffix: <ChevronRightSmall />,
    },
  },
  radioGroup: {
    spacing: '0px',
  },
  rangePicker: {
    size: 'small',
    width: '100%',
    zIndex: 2000,
  },
};
